'use client'
import { listAnatomy as parts } from '@chakra-ui/anatomy'
import { List as ChakraList } from '@chakra-ui/react'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'
import { forwardRef, LegacyRef } from 'react'

import { ListProps } from './List.types'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const menuListStyleVariant = definePartsStyle({
  container: {
    shadow: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
    color: 'gray.800',
    position: 'relative',
    cursor: 'pointer',
    borderRadius: '0 0.5rem 0.5rem 0',
    fontWeight: 'normal',
    '&[aria-selected=true]': {
      color: 'blue.500',
      borderLeftColor: 'blue.500',
      borderLeft: '0.25rem solid',
      fontWeight: '600',
    },
    '&[aria-disabled=true]': {
      color: 'gray.500',
      cursor: 'not-allowed',
    },
    '&:hover': {
      backgroundColor: 'blue.50',
    },
    '&:active': {
      backgroundColor: 'blue.100',
    },
  },
  icon: {
    fontSize: '1rem',
    '&[aria-selected=true]': {
      color: 'blue.500',
    },
    '&[aria-disabled=true]': {
      color: 'gray.500',
      cursor: 'not-allowed',
    },
  },
})

export const ListStyle = defineMultiStyleConfig({
  variants: {
    menuList: menuListStyleVariant,
  },
})

export default forwardRef(function List(
  props: ListProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraList {...props} ref={ref} translate="no" />
})
